import * as React from 'react';
export const IcHdrOff = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12.27 8l2.55 2.55A3.08 3.08 0 0012.27 8zM4.71 3.29a1.004 1.004 0 10-1.42 1.42l3.37 3.36A1 1 0 006 9v2H4V9a1 1 0 00-2 0v6a1 1 0 102 0v-2h2v2a1 1 0 102 0V9.41l1 1V15a1 1 0 001 1h2a2.76 2.76 0 001.81-.77l5.48 5.48a1.002 1.002 0 001.639-.325 1 1 0 00-.219-1.095l-16-16zM12 14h-1v-1.59l1.4 1.41a.87.87 0 01-.4.18zm9.18-.92A3 3 0 0019 8h-2a1 1 0 00-1 1v2.76L18.24 14H19c.12.01.24.01.36 0l.75 1.49A1 1 0 0021 16a.93.93 0 00.45-.11 1 1 0 00.44-1.34l-.71-1.47zM19 12h-1v-2h1a1 1 0 110 2z'
      fill='currentColor'
    />
  </svg>
);
